import { post } from './api';
import '../mock-data/promoteItem.mock';

const endpoints = {
  PromoteItemUrl: `${window.envConfig.SELLERS_API_BASE_URL}Users/promoteitem`,
};

export type PromoteItemReturn = {
  message: string;
};

export type PromoteItemRequest = {
  lotSku: string | number;
  itemName: string;
  message: string;
};

export const submitPromoteItem = async (
  request: PromoteItemRequest,
  token: string
): Promise<PromoteItemReturn> => {
  const results = await post<PromoteItemReturn>({
    url: endpoints.PromoteItemUrl,
    body: request as any,
    token,
  });

  return results;
};
